<header>
  <div class="contentHeader">
    <div class="goBack">
      @if (redirectBackPath) {
        <span routerLink="{{ redirectBackPath }}"> <mat-icon class="icono">arrow_back</mat-icon> Volver </span>
      }
      <h3>{{ title() }}</h3>
    </div>

    @if (showButtonCreate) {
      <ng-template [permissions]="permissions" [permissionGranted]="userActions.ALTA" [requireSpecialValidations]="false">
        <div class="contenedorBoton">
          <button class="btnValid" [matTooltip]="button()" (click)="navigate()">{{ button() }}</button>
        </div>
      </ng-template>
    }
  </div>

  <p>
    {{ headerName() }} &nbsp;
    @if (headerName.length > 1) {
      {{ pipe() }} &nbsp;
    }
    {{ description() }}
  </p>
</header>
